import axios from 'axios';
import { resolvePmApiConfig, describePmApiMisconfiguration } from './config/pmApiConfig';

// Dedicated client for the Project Management module (Go backend).
// Kept separate from src/api.js (Java backend) so PM can be pointed at its
// own instance without affecting CRM/Audit modules.
//
// The endpoint MUST be supplied per environment via REACT_APP_PM_API_ENDPOINT.
// There is deliberately no default host: see src/config/pmApiConfig.js for why
// a cross-environment fallback turned a missing deploy variable into a silent
// 404 on /pm/dashboard across dev and staging.
//
// PM requires auth (per-project access control — see
// CBQAGLOBAL-CRM-BACKEND-GOLANG's config/middleware/pm.go): forwards the
// same Java-issued JWT the user already has, same token-retrieval logic as
// src/apiHris.js.
const pmApiConfig = resolvePmApiConfig();

const apiPm = axios.create({
  baseURL: pmApiConfig.baseURL,
});

apiPm.interceptors.request.use((config) => {
  if (!pmApiConfig.isConfigured) {
    // Fail before the request leaves the browser: an unconfigured client would
    // otherwise resolve relative to the frontend's own origin and surface as a
    // confusing HTML/404 response rather than a configuration problem.
    throw new Error(describePmApiMisconfiguration());
  }

  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user') || '{}');
  } catch (error) {
    user = null;
  }

  const token = user?.token || user?.accessToken || localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiPm;
